module.exports = __webpack_public_path__ + "static/media/verbs_in_ui5.096e835b.JPG";